import { getConsultationHistory, respondToConsultation } from "../../../Common/axios_instance/video_https/video.https";
import { ConsultationHistoryParams } from "../../../Common/axios_instance/video_https/interfaces/video_https.interface";

export const fetchNotificationHistory = (params: ConsultationHistoryParams) =>
  getConsultationHistory(params);

export const respondToRequest = (consultationId: string, status: "accepted" | "rejected") =>
  respondToConsultation(consultationId, status);
